/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Invalid_Date_Range_HourInputs */

const en_admin_external_booking_edit_invalid_date_range_hour = /** @type {(inputs: Admin_External_Booking_Edit_Invalid_Date_Range_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The end must be after the start.`)
};

const de_admin_external_booking_edit_invalid_date_range_hour = /** @type {(inputs: Admin_External_Booking_Edit_Invalid_Date_Range_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Ende muss nach dem Start liegen.`)
};

const es_admin_external_booking_edit_invalid_date_range_hour = /** @type {(inputs: Admin_External_Booking_Edit_Invalid_Date_Range_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El fin debe ser posterior al inicio.`)
};

const fr_admin_external_booking_edit_invalid_date_range_hour = /** @type {(inputs: Admin_External_Booking_Edit_Invalid_Date_Range_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La fin doit être postérieure au début.`)
};

const nl_admin_external_booking_edit_invalid_date_range_hour = /** @type {(inputs: Admin_External_Booking_Edit_Invalid_Date_Range_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het einde moet na de start liggen.`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Invalid_Date_Range_HourInputs) => LocalizedString} */
const it_admin_external_booking_edit_invalid_date_range_hour = en_admin_external_booking_edit_invalid_date_range_hour;

/** @type {(inputs: Admin_External_Booking_Edit_Invalid_Date_Range_HourInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_invalid_date_range_hour = en_admin_external_booking_edit_invalid_date_range_hour;

/** @type {(inputs: Admin_External_Booking_Edit_Invalid_Date_Range_HourInputs) => LocalizedString} */
const pl_admin_external_booking_edit_invalid_date_range_hour = en_admin_external_booking_edit_invalid_date_range_hour;

/** @type {(inputs: Admin_External_Booking_Edit_Invalid_Date_Range_HourInputs) => LocalizedString} */
const hu_admin_external_booking_edit_invalid_date_range_hour = en_admin_external_booking_edit_invalid_date_range_hour;

/** @type {(inputs: Admin_External_Booking_Edit_Invalid_Date_Range_HourInputs) => LocalizedString} */
const ro_admin_external_booking_edit_invalid_date_range_hour = en_admin_external_booking_edit_invalid_date_range_hour;

/**
* | output |
* | --- |
* | "The end must be after the start." |
*
* @param {Admin_External_Booking_Edit_Invalid_Date_Range_HourInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_invalid_date_range_hour = /** @type {((inputs?: Admin_External_Booking_Edit_Invalid_Date_Range_HourInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Invalid_Date_Range_HourInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_invalid_date_range_hour(inputs)
	if (locale === "de") return de_admin_external_booking_edit_invalid_date_range_hour(inputs)
	if (locale === "es") return es_admin_external_booking_edit_invalid_date_range_hour(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_invalid_date_range_hour(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_invalid_date_range_hour(inputs)
	if (locale === "it") return it_admin_external_booking_edit_invalid_date_range_hour(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_invalid_date_range_hour(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_invalid_date_range_hour(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_invalid_date_range_hour(inputs)
	return ro_admin_external_booking_edit_invalid_date_range_hour(inputs)
});
export { admin_external_booking_edit_invalid_date_range_hour as "admin.external_booking_edit.invalid_date_range_hour" }